import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import Input from "../../../../../components/Input/Input";
import Button from "../../../../../components/Buttons/Button";
import { validateOtpForCustomer, customerLogin, setOtpSent } from "../../../customerAction";
import Box from "../../../../../components/Box";
import Icon from "../../../../../components/Icon";
import Label from "../../../../../components/Label";
import truncate from "lodash/truncate";
import isEmail from "validator/lib/isEmail";
import ErrorMessage from "../../../../../components/ErrorMessage";
import { VALIDATE_OTP } from "../../../customerActionType";
import useActiveData from "../../../../../customHooks/useActiveData";

const MediaContainer = styled(Box)`
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
`;

const TextOrContainer = styled(Box)`
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
`;

const MediaBox = styled(Box)`
  border: 1px solid #D9DBE9;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
`;

const UserLogin = () => {
  const dispatch = useDispatch();
  const websiteData = useActiveData();

  let timer;
  const sendOtpDetail = useSelector((state) => state?.customerReducer?.signUp_data);

  const is_customer_found = useSelector((state) => state?.customerReducer?.is_customer_found);

  const isOtpSent = useSelector((state) => state?.customerReducer?.isOtpSent);
  const otp_error = useSelector((state) => state?.customerReducer?.otp_error);

  const user_id = useSelector(
    (state) => state?.customerReducer?.validate_data?.customer?._id
  );
  const isSentOtp = sendOtpDetail?.is_otp_sent;

  const [modalView, setModalView] = useState("login-page");

  useEffect(() => {
    if (isOtpSent) {
      setModalView("otp-page")
    } else {
      setModalView("login-page")
    }
  })

  const [user, setUserData] = useState({
    contact_email: "",
  });
  const [seconds, setSeconds] = useState("24");

  const [minutes, setMinutes] = useState("0");

  const [otpInput, setOtpInput] = useState({
    input1: "",
    input2: "",
    input3: "",
    input4: "",
  });

  const [errors, setErrors] = useState({});

  const firstInput = useRef();
  const secondInput = useRef();
  const thirdInput = useRef();
  const forthInput = useRef();

  const handleOnChange = (keyName, keyValue) => {
    dispatch({
      type: VALIDATE_OTP,
      isFetching: true,
    });
    const maxLength = 1; // Set the desired maximum length

    const otpDetails = {...otpInput};

    if (keyValue.length > maxLength) {
      return null;
    } else {
      otpDetails[keyName] = keyValue
      setOtpInput(otpDetails)
    }
  }

  useEffect(() => {
    window.fbAsyncInit = function() {
      window.FB.init({
        appId      : '599855388891439',
        cookie     : true,                     // Enable cookies to allow the server to access the session.
        xfbml      : true,                     // Parse social plugins on this webpage.
        version    : '{api-version}'           // Use this Graph API version for this call.
      });
      window.FB.getLoginStatus(function(response) {   // Called after the JS SDK has been initialized.
        console.log(response);        // Returns the login status.
      });
    };
  }, []);


  useEffect(() => {
    timer =
      seconds > 0 &&
      setInterval(() => {
        setSeconds(seconds - 1);
      }, 1000);
    return () => clearInterval(timer);
  }, [seconds]);

  useEffect(() => {
    if (user_id) {
      setModalView("success-page");
    }
  }, [user_id]);

  useEffect(() => {
    if (isSentOtp) {
      setModalView("otp-page");
    }
  }, [isSentOtp]);

  const handleChangeUser = (keyName, keyValue) => {
    let update = { ...user };
    update[keyName] = keyValue;
    setUserData(update);
  };

  const handleValidation = () => {
    let isValid = true;
    let error = {};
    if (!user.contact_email.trim() || !isEmail(user.contact_email.trim())) {
      isValid = false;
      error["contact_email"] = "Please enter valid email address";
    }
    return {
      isValid,
      error
    };
  }

  const sendOtpHandle = (isResend) => {
    setErrors({});
    setUserData({contact_email: user?.contact_email.trim()});
    let validate = handleValidation();
    if (validate.isValid) {
      const agent = {
        contact_email: user?.contact_email.trim(),
      };
      if (agent) {
        dispatch(customerLogin(agent, isResend));
      }
    } else {
      setErrors(validate.error);
    }
  };

  const submitOtpHandle = () => {
    const body = {
      contact_email: user?.contact_email,
      local_otp: otpInput.input1 + otpInput.input2 + otpInput.input3 + otpInput.input4,
    };

    if (body) {
      dispatch(validateOtpForCustomer(body))
    }
  };

  const handleClickRegister = () => {
    window.location = "/?register=true&asMember=true";
  }

  const onClickHandle = () => {
    dispatch(setOtpSent(false));
    setModalView("login-page")
  }

  const attemptFacebookLogin = () => {
    if (window.FB) {
      window.FB.login(function(response){
        // handle the response
        console.log("Fb", response);
      }, {scope: 'public_profile,email'});
    }
  }

  const onSignIn = (googleUser) => {
    var profile = window.googleUser?.getBasicProfile();
    console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
    console.log('Name: ' + profile.getName());
    console.log('Image URL: ' + profile?.getImageUrl());
    console.log('Email: ' + profile?.getEmail()); // This is null if the 'email' scope is not present.
  }

  return (
    <div className="admin-login">
      {modalView === "login-page" ? (
        <div>
          <MediaContainer>
            <div className={"g-signin2"} data-onsuccess="onSignIn">
              <MediaBox
                  // onClick={() => onSignIn()}
                  mr="25px"><Icon iconName="googleLogo"/></MediaBox>
            </div>
              <MediaBox onClick={() => attemptFacebookLogin()}><Icon iconName="facebookLogo"/></MediaBox>
          </MediaContainer>
          <TextOrContainer>
            <Label color="#A0AEC0" fontWeight={500}>Or</Label>
          </TextOrContainer>

          <Label mb="8px">{websiteData?.LOGIN_PAGE_LOGIN_SEGMENT_EMAIL_FORM_TEXT}*</Label>
          <Input
            value={user.contact_email}
            onChange={(e) => handleChangeUser("contact_email", e.target.value)}
            border={user?.contact_email?.length ? "1px solid #606734" : null}
            placeholder="Enter Your Email ID"
            className="input-box"
            type="text"
            height="46px"
          />
          {errors.contact_email && <ErrorMessage>{errors.contact_email}</ErrorMessage>}
          {
            is_customer_found &&
            <ErrorMessage>
                This contact Email is not registered with us.
            </ErrorMessage>
          }
          <div className="d-flex justify-content-center mt-4">
            <Button
              bg={user.contact_email ? "#D0004B" : "#A0AEC0"}
              text="SEND OTP"
              disabled={user.contact_email ? "" : "true"}
              onClick={() => sendOtpHandle(false)}
            />
          </div>
        </div>
      ) : null}
      {/* otp-page */}
      {modalView === "otp-page" ? (
        <>
          <p className="d-flex justify-content-between">
            Your Email Id <b>{truncate(user.contact_email, { length: 23 })}</b>
            <div onClick={() => onClickHandle()} style={{cursor: "pointer"}}>
              <img src="https://ik.imagekit.io/rzlzf40okya/elixir/edit.svg" />
            </div>
          </p>
          <Label mb="8px">Enter OTP</Label>
          <div className="otp-bx">
            <input
              ref={firstInput}
              className={otp_error ? "otp-input otp-err" : "otp-input"}
              type="number"
              maxLength="1"
              value={otpInput.input1}
              onChange={(e) => {
                handleOnChange("input1", e.target.value)
                e.target.value && secondInput.current.focus();
              }}
            />
            <input
              ref={secondInput}
              className={otp_error ? "otp-input otp-err" : "otp-input"}
              type="number"
              maxLength="1"
              value={otpInput.input2}
              onChange={(e) => {
                handleOnChange("input2", e.target.value)
                !e.target.value
                  ? firstInput.current.focus()
                  : thirdInput.current.focus();
              }}
            />
            <input
              ref={thirdInput}
              className={otp_error ? "otp-input otp-err" : "otp-input"}
              type="number"
              maxLength="1"
              value={otpInput.input3}
              onChange={(e) => {
                handleOnChange("input3", e.target.value)
                !e.target.value
                  ? secondInput.current.focus()
                  : forthInput.current.focus();
              }}
            />
            <input
              ref={forthInput}
              className={otp_error ? "otp-input otp-err" : "otp-input"}
              type="number"
              maxLength="1"
              value={otpInput.input4}
              onChange={(e) => {
                handleOnChange("input4", e.target.value)
                !e.target.value && thirdInput.current.focus();
              }}
            />
          </div>
          <div className="TimerBody">
            <div>
              {minutes < 10 ? "0" + minutes : minutes}:
              {seconds < 10 ? "0" + seconds : seconds}
            </div>
            <div className="ResendLabel" onClick={() => sendOtpHandle(true)}>Resend OTP</div>
          </div>
          {
              otp_error &&
              <Box my="25px" color="#FE1717" textAlign="center">{otp_error}</Box>
          }
          <Button
            bg={(otpInput.input1 && otpInput.input2 && otpInput.input3 && otpInput.input4) ? "#D0004B" : "#A0AEC0"}
            text="Login Now"
            disabled={!(otpInput.input1 && otpInput.input2 && otpInput.input3 && otpInput.input4)}
            margin="auto"
            mt="18px"
            mb="18px"
            textColor="#fff"
            onClick={submitOtpHandle}
          />
        </>
      ) : null}
      <div>
        <a onClick={() => handleClickRegister()} style={{cursor: "pointer"}}>
          {websiteData?.LOGIN_PAGE_LOGIN_SEGMENT_SUBMIT_REGISTER_TEXT}{" "}
          <b style={{ color: "#D0004B" }}>{websiteData?.LOGIN_PAGE_LOGIN_SEGMENT_SUBMIT_REGISTER_BTN_TEXT}</b>
        </a>
      </div>
    </div>
  );
}

export default UserLogin;
